// extracted by mini-css-extract-plugin
module.exports = {"trialCourseItemColumn":"style_trialCourseItemColumn__wHbMp","item":"style_item__k_Mjx","borderRight":"style_borderRight__n4onY"};